import Callback from '@/services/Callback'
import To from 'await-to-js'
import qs from 'qs'
import { wizStandardInstance, diyInstance } from './instance'

export default class DataRuleSettingService {
  // 获取实体列表
  static async getEntifyList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/QS/StdClass/get_entity_list?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 查询类别属性
  static async getClassList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassAttribute?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取规则列表
  static async getRuleList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdDataQualityRule?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取规则详情
  static async getRuleDetail(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdDataQualityRule/${payload.id}`)
    )
    return Callback(err, res)
  }
  // 获取字典
  static async getDic(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/DataCategory?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取规则类别列表
  static async getRuleClass(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/DataItem?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 新增
  static async add(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/StdDataQualityRule', payload))
    return Callback(err, res)
  }
  // 新增
  static async createList(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdDataQualityRule/create-list', payload)
    )
    return Callback(err, res)
  }
  // 更新
  static async update(payload) {
    const [err, res] = await To(wizStandardInstance.patch('/api/std/StdDataQualityRule', payload))
    return Callback(err, res)
  }
  // 删除
  static async remove(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/StdDataQualityRule', { data: payload })
    )
    return Callback(err, res)
  }
  // 获取规则正则下拉
  static async getRegularList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdDataQualityRule/get_regular_list?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 添加到任务
  // static async addToTask(payload) {
  //   const [err, res] = await To(
  //     wizStandardInstance.post('/api/std/StdDataQualityRule/insert_rule_to_task', payload)
  //   )
  //   return Callback(err, res)
  // }
  // 添加到-新
  static async addToTask(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdDataQualityRule/insert-rules-to-tasks', payload)
    )
    return Callback(err, res)
  }
  // 导出数据规则设置
  static async export(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdDataQualityRule/export_data', payload, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  // 导入模板
  static async downloadTemplate() {
    const [err, res] = await To(
      wizStandardInstance.get('api/std/StdDataQualityRule/download-template', {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  // 导入数据规则设置
  static async import(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('api/std/StdDataQualityRule/import_data', payload, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  // 获取列表数据
  static async getQualityRuleList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdDataQualityRule/paged-list?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取左侧树数据
  static async getRuleTreeNodes(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdDataQualityRule/rule-tree-nodes?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 启用
  static async toEnabled(payload) {
    const [err, res] = await To(
      wizStandardInstance.put('/api/std/StdDataQualityRule/enabled', payload)
    )
    return Callback(err, res)
  }
  // 审批策略（新增）
  static async addApprovalStategy(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/ApprovalStategy', payload))
    return Callback(err, res)
  }
  // 审批策略（删除）
  static async deleteApprovalStategy(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/ApprovalStategy', { data: payload })
    )
    return Callback(err, res)
  }
  // 审批策略（更新）
  static async updateApprovalStategy(payload) {
    const [err, res] = await To(wizStandardInstance.put('/api/std/ApprovalStategy', payload))
    return Callback(err, res)
  }
  // 审批策略（查询）
  static async getApprovalStategy(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/ApprovalStategy/paged-result?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取审批策略列表
  static async getStategyList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/ApprovalStategy/stategy-list?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取工作流列表
  static async getWorkflowList(payload) {
    const [err, res] = await To(diyInstance.post('/api/FormEngine/getTableData', payload))
    return Callback(err, res)
  }
  // 审批记录（新增）
  static async createApprovalRecord(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/ApprovalStategy/create-approval-record', payload)
    )
    return Callback(err, res)
  }
  // 审批记录（更新）
  static async updateApprovalRecord(payload) {
    const [err, res] = await To(
      wizStandardInstance.put('/api/std/ApprovalStategy/update-approval-record', payload)
    )
    return Callback(err, res)
  }
  // 审批记录（删除）
  static async deleteApprovalRecord(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/ApprovalStategy/delete-approval-record', {
        data: payload,
      })
    )
    return Callback(err, res)
  }
  // 审批记录（查询）
  static async getApprovalRecord(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/ApprovalStategy/approval-record-paged-result', payload)
    )
    return Callback(err, res)
  }
  // 审批或驳回
  static async passedOrRejected(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/ApprovalStategy/passed-or-rejected', payload)
    )
    return Callback(err, res)
  }
  // 根据审批记录id获取数据id集合
  static async getIdsByApprovalRecordId(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/ApprovalStategy/data-ids/${payload}`)
    )
    return Callback(err, res)
  }
  // 提交
  static async commit(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/ApprovalStategy/commit', payload)
    )
    return Callback(err, res)
  }
  // 获取数据各个 id
  static async getRecordId(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/ApprovalStategy/approval-record/${payload}`)
    )
    return Callback(err, res)
  }
  // 审批流程节点
  static async getWFHistory(payload) {
    const [err, res] = await To(diyInstance.post('/api/WorkFlow/getWFHistory', payload))
    return Callback(err, res)
  }
  // 用户头像
  static async getUserAvatar(payload) {
    const [err, res] = await To(diyInstance.post('/api/SysUser/getSysUserPublicInfo', payload))
    return Callback(err, res)
  }
  // 流程图节点
  static async getFlowNode(payload) {
    const [err, res] = await To(diyInstance.post('/api/FormEngine/getTableData', payload))
    return Callback(err, res)
  }
  // 建立审批策略的实体
  static async getApprovalStategyEntity(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/ApprovalStategy/has-approval-stategy-classes/${payload}`)
    )
    return Callback(err, res)
  }
  // 查询数据权限审核和工作流对应关系
  static async getWorkflowRelationInfo(payload) {
    const [err, res] = await To(
      wizStandardInstance.post(
        '/api/std/AuthorizationClass/get-authorization-class-workflow-relation-info',
        payload
      )
    )
    return Callback(err, res)
  }
  // 数据权限审核
  static async permissionsAudit(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/AuthorizationClass/audit', payload)
    )
    return Callback(err, res)
  }
  // 数据权限审核作废
  static async permissionsAuditCancel(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/AuthorizationClass/audit-cancel', payload)
    )
    return Callback(err, res)
  }
  // 获取低代码待办数据列表,formData方式传参
  static async getWFWork(payload) {
    const [err, res] = await To(diyInstance.post('/api/WorkFlow/getWFWork', payload))
    return Callback(err, res)
  }
}
